/** Deduction fractions that would wipe out or invert the value if they reached 1. */
const FRACTION_LIMITS = [
    { id: 'dep', label: 'Age depreciation' },
    { id: 'mileage', label: 'Mileage penalty' },
    { id: 'owner', label: 'Owner penalty' },
    { id: 'inspection', label: 'Combined inspection deduction' },
];
export const validateOutputs = (run) => {
    const issues = [];
    const value = (id) => run.outputs[id];
    for (const { id, label } of FRACTION_LIMITS) {
        const result = value(id);
        if (typeof result === 'number' && result >= 1) {
            issues.push({
                code: 'OUT_OF_BOUNDS',
                equationId: id,
                detail: `${label} reached ${result}; a combined deduction of 100% or more is not approved`,
            });
        }
        if (typeof result === 'number' && result < 0) {
            issues.push({ code: 'OUT_OF_BOUNDS', equationId: id, detail: `${label} is negative (${result})` });
        }
    }
    const age = value('age');
    if (typeof age === 'number' && age < 0) {
        issues.push({ code: 'OUT_OF_BOUNDS', equationId: 'age', detail: 'The vehicle age is negative' });
    }
    for (const id of ['base', 'inspected', 'appraisal']) {
        const result = value(id);
        if (typeof result === 'number' && result < 0) {
            issues.push({ code: 'NEGATIVE_VALUE', equationId: id, detail: `"${id}" is negative; the valuation is blocked rather than clipped to zero` });
        }
    }
    for (const id of ['appraisal', 'costs', 'ceiling', 'total', 'retail']) {
        if (value(id) === null || value(id) === undefined) {
            issues.push({ code: 'NOT_CALCULATED', equationId: id, detail: `"${id}" could not be calculated from the inputs supplied` });
        }
    }
    const ceiling = value('ceiling');
    return {
        ok: issues.length === 0,
        issues,
        noEconomicOffer: typeof ceiling === 'number' && ceiling < 0,
    };
};
//# sourceMappingURL=validate-outputs.js.map